class Logger {
    constructor () {

    }

    error (message, ...optionalParams) {
        // eslint-disable-next-line no-console
        console.error(message, optionalParams)
    }

    info (message, ...optionalParams) {
        // eslint-disable-next-line no-console
        console.info(message, optionalParams)
    }

    log (message, ...optionalParams) {
        // eslint-disable-next-line no-console
        console.log(message, optionalParams)
    }

    debug (message, ...optionalParams) {
        // eslint-disable-next-line no-console
        console.debug(message, optionalParams)
    }

    warn (message, ...optionalParams) {
        // eslint-disable-next-line no-console
        console.warn(message, optionalParams)
    }

    group (label) {
        // eslint-disable-next-line no-console
        console.group(label)
    }

    groupEnd () {
        // eslint-disable-next-line no-console
        console.groupEnd()
    }
}

export default new Logger()
